import toastr from "toastr";
import {Loading} from "../helpers/loading/loading";
import {Modal} from "../helpers/modal/modal";
import {Options, Vue} from "vue-class-component";

@Options({
	components: {
		Loading,
		Modal
	}
})
export class Base extends Vue {
	loading = false;

	get site_data() {
		// console.log((window as any).site_data)
		return {...(window as any).site_data};
	}

	errorHandle(err: Error) {
		console.error(err);

		// const message = err.response?.data?.message || err.message;

		toastr.error(err.message);

		this.loading = false;
	}

	wait(time = 0) {
		return new Promise<void>(resolve => {
			setTimeout(() => {
				resolve();
			}, time);
		});
	}
}
